import forDevice from '../../hoc/for-device';
import AppDesktop from './app-desktop';
import AppMobile from './app-mobile';

export default forDevice(AppMobile, AppDesktop);
